var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1192_20832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C19.1264 0 24.5 5.37364 24.5 12C24.5 18.6264 19.1264 24 12.5 24C5.87364 24 0.5 18.6264 0.5 12C0.5 5.37364 5.87364 0 12.5 0ZM6.4348 16.3435L10.7783 12L6.4348 7.65647C6.18564 7.40721 6.18564 7.00063 6.4348 6.75146L7.25146 5.9348C7.50063 5.68564 7.90721 5.68564 8.15647 5.9348L12.5 10.2783L16.8435 5.9348C17.0928 5.68564 17.4994 5.68564 17.7485 5.9348L18.5652 6.75146C18.8144 7.00063 18.8144 7.40721 18.5652 7.65647L14.2217 12L18.5652 16.3435C18.8144 16.5928 18.8144 16.9994 18.5652 17.2485L17.7485 18.0652C17.4994 18.3144 17.0928 18.3144 16.8435 18.0652L12.5 13.7217L8.15647 18.0652C7.90721 18.3144 7.50063 18.3144 7.25146 18.0652L6.4348 17.2485C6.18564 16.9994 6.18564 16.5928 6.4348 16.3435Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1192_20832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogoIcon);
export default __webpack_public_path__ + "static/media/nogo-icon.ff9f3ba3d27a621f47e13d8bc8539377.svg";
export { ForwardRef as ReactComponent };